import { render, staticRenderFns } from "./StatisticsWdTurnover.vue?vue&type=template&id=550dff79&"
import script from "./StatisticsWdTurnover.vue?vue&type=script&lang=js&"
export * from "./StatisticsWdTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports